module.exports = __webpack_public_path__ + "img/test-bg.82563e22.jpg";